import { FqaComponent } from './fqa/fqa.component';
import { BuildsService } from './Services/builds/builds.service';
import { ProductService } from './Services/product.service';
import { GamesService } from './Services/games.service';
import { LoginService } from './Services/login.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {FormsModule,ReactiveFormsModule} from '@angular/forms'
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { Router } from '@angular/router/src/router';
import { RouterModule } from '@angular/router';
import { masterRoutes } from './app.routes';
import { AuthoService } from './Services/autho.service';
import { HttpModule } from '@angular/http';
import { UsersComponent } from './users/users.component';
import { GamesComponent } from './games/games.component';
import { GamepageComponent } from './gamepage/gamepage.component';
import { SafePipe } from './pipes/safe.pipe';
import { UsersService } from './Services/users.service';
import { HeaderComponent } from './header/header.component';
import { AddgameComponent } from './addgame/addgame.component';
import { HTTP_INTERCEPTORS ,HttpClientModule } from '@angular/common/http';
import { InterceptorService } from './Services/interceptor.service';
import{FilterModule} from './pipes/filter.module';
import { EditgameComponent } from './editgame/editgame.component';
import { AdduserComponent } from './adduser/adduser.component';
import { ApproveComponent } from './approve/approve.component';
import { FeaturesComponent } from './features/features.component';
import { CommentcontrolComponent } from './commentcontrol/commentcontrol.component';
import { CommentsService } from './Services/comments.service';
import { CatcontrolComponent } from './catcontrol/catcontrol.component';
import { AddProductComponent } from './add-product/add-product.component';
import { JwPaginationComponent } from 'jw-angular-pagination';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';


import { BuildsComponent } from './builds/builds.component';
import { TermConditionComponent } from './term-condition/term-condition.component';



@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    UsersComponent,
    GamesComponent,
    GamepageComponent,
    SafePipe,
    HeaderComponent,
    AddgameComponent,
    EditgameComponent,
    AdduserComponent,
    ApproveComponent,
    FeaturesComponent,
    CommentcontrolComponent,
    CatcontrolComponent,
    AddProductComponent,
    BuildsComponent,
    FqaComponent,
    TermConditionComponent,
     JwPaginationComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    FilterModule,
    NgMultiSelectDropDownModule,
    RouterModule.forRoot(masterRoutes)
  ],
  providers: [ {
    provide: HTTP_INTERCEPTORS,
    useClass: InterceptorService,
    multi: true
  }, AuthoService, LoginService, UsersService, GamesService, CommentsService, ProductService, BuildsService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/app.module.ts